/**
 * システム管理者によるテナント切替の「アクティブテナント」を保持する。
 *
 * 保存値はバックエンドの X-Act-As-Tenant-Id ヘッダに載せて全 REST 呼び出しに反映される。
 * バックエンド側は is_system_admin のユーザーに対してのみこのヘッダを尊重するため、
 * 非管理者がこの値を設定しても効果はない（権限昇格は起きない）。
 */
const ACTIVE_TENANT_KEY = "strix.activeTenantId";

/**
 * 現在のアクティブテナントID（未設定なら null = 自テナント）を取得する。
 * @return {string | null} アクティブテナントID、未設定時は null
 */
export function getActiveTenantId(): string | null {
  try {
    return localStorage.getItem(ACTIVE_TENANT_KEY);
  } catch (_e) {
    return null;
  }
}

/**
 * アクティブテナントIDを保存する（null で自テナントに戻す）。
 * @param {string | null} tenantId 設定するテナントID（null で解除）
 * @return {void}
 */
export function setActiveTenantId(tenantId: string | null): void {
  try {
    if (tenantId) {
      localStorage.setItem(ACTIVE_TENANT_KEY, tenantId);
    } else {
      localStorage.removeItem(ACTIVE_TENANT_KEY);
    }
  } catch (_e) {
    // localStorage 利用不可（プライベートモード等）は無視する
  }
}
